import { MeasurementData } from 'features/weather/types';
import {
  convertNumberFromDB,
  convertToImperial,
  getUnitForMeasurementType,
} from 'features/weather/utils/dataConverters';
import { getLabelForMeasurementType } from 'features/weatherAlerts/utils/dataConverters';
import { Dish, Location } from 'types';
import { WeatherAlertMap, WeatherAlertRow } from '../types';

export const getAlertText = (
  condition: MeasurementData,
  datum: number,
  alertThreshold: number,
  inImperial: boolean | null | undefined
) => {
  const alertText =
    getLabelForMeasurementType(condition) +
    ': ' +
    convertNumberFromDB(
      convertToImperial(datum, condition, inImperial),
      condition
    )?.toFixed(2) +
    ' ' +
    getUnitForMeasurementType(condition, inImperial) +
    ' > ' +
    convertNumberFromDB(
      convertToImperial(alertThreshold, condition, inImperial),
      condition
    )?.toFixed(2) +
    ' ' +
    getUnitForMeasurementType(condition, inImperial);
  return alertText;
};

export const getWeatherAlertMap = (
  dishes: Dish[] | undefined,
  locations: Location[] | undefined,
  useImperial: boolean | null | undefined,
  getAnalyzerIdsForDish: (dish: Dish) => number[]
) => {
  const weatherAlertMap: WeatherAlertMap = {};
  if (dishes === undefined) return weatherAlertMap;

  dishLoop: for (const dish of dishes) {
    const weatherAlertRows: WeatherAlertRow[] = [];
    const associatedLocation = locations?.find(
      (item) => item.id === dish.location_id
    );
    // Skip dishes without associated locations or current weather
    if (
      !dish.location_id ||
      !dish.weatherAlerts ||
      dish.weatherAlerts.length === 0 ||
      !associatedLocation ||
      !associatedLocation.weather ||
      associatedLocation.weather.length === 0
    )
      continue;
    // Check associated weather alerts for violations
    for (const alert of dish.weatherAlerts) {
      const weather = associatedLocation.weather[0];
      if (!weather) continue dishLoop;
      if (!alert.enabled) continue;
      const weatherCondition = weather[alert.condition];
      if (!weatherCondition) continue;
      // Check for warning alerts, storing relevant information for widget display
      if (weatherCondition > alert.warning) {
        weatherAlertRows.push({
          warning: true,
          alertText: getAlertText(
            alert.condition as MeasurementData,
            weatherCondition,
            alert.warning,
            useImperial
          ),
          condition: alert.condition,
        });
        // Check for caution alerts
      } else if (alert.caution && weatherCondition > alert.caution) {
        weatherAlertRows.push({
          warning: false,
          alertText: getAlertText(
            alert.condition as MeasurementData,
            weatherCondition,
            alert.caution,
            useImperial
          ),
          condition: alert.condition,
        });
      }
    }
    const analyzers = getAnalyzerIdsForDish(dish);
    if (weatherAlertRows.length > 0)
      weatherAlertMap[dish.name] = {
        rows: weatherAlertRows,
        analyzerIds: analyzers,
      };
  }
  return weatherAlertMap;
};
